import { useQuery } from '@hooks/reactQuery';

import { getGoldenSettingsSites } from '@api/goldenSettings';

import { extractQueryParams } from '@utils/common';
import { fieldsOptionsFormatted } from '@utils/formatter';

import { TCMSitesIdsDTO } from '@interfaces/cmModule/dto/cmModuleDTO';
import { IValueLabel } from '@interfaces/common/common';

import { refetchOptions } from '@constants/common';
import { GOLDEN_SETTING_SITES } from '@constants/queryKeys';

interface IUseQueryGoldenSettingsSitesReturnType {
	goldenSettingsSites: IValueLabel[];
	isLoadingGoldenSettingsSites: boolean;
}

const useQueryGoldenSettingsSites = (
	params: Partial<TCMSitesIdsDTO>,
): IUseQueryGoldenSettingsSitesReturnType => {
	const {
		vendor,
		technology,
		nodeType,
	} = params;

	const {
		data: goldenSettingsSites,
		isLoading: isLoadingGoldenSettingsSites,
		isFetching: isFetchingGoldenSettingsDates,
	} = useQuery({
		queryKey: [GOLDEN_SETTING_SITES, params],
		queryFn: extractQueryParams(getGoldenSettingsSites),
		select: (options) => fieldsOptionsFormatted(options || []),
		enabled: [vendor, technology, nodeType],
		...refetchOptions,
	});

	return {
		goldenSettingsSites: goldenSettingsSites || [],
		isLoadingGoldenSettingsSites: (isLoadingGoldenSettingsSites && !!goldenSettingsSites)
			|| isFetchingGoldenSettingsDates,
	};
};

export default useQueryGoldenSettingsSites;
